import fetch from 'isomorphic-fetch';
// import { EventTypes } from 'redux-segment';
import { REQUEST_SEARCH, RECEIVE_SEARCH, TOGGLE_FACET_VALUE, RESET_FACET_VALUES, SELECT_COLLECTION, UPDATE_SORT, RESET, REQUEST_DEFAULT_GIFT_CARD, RECEIVE_DEFAULT_GIFT_CARD } from './types/RegistryCollectionActionTypes';

// TODO: MOVE THIS AND USE FOR ALL REQUESTS!!!!
function handleErrors(response) {
  if (!response.ok) {
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return response;
}

export function reset() {
  return {
    type: RESET
  };
}

function requestSearch() {
  return {
    type: REQUEST_SEARCH
  };
}

function receiveSearch(json) {
  return {
    type: RECEIVE_SEARCH,
    payload: json
  };
}

function requestDefaultGiftCard() {
  return {
    type: REQUEST_DEFAULT_GIFT_CARD
  };
}

function receivedDefaultGiftCard(json) {
  return {
    type: RECEIVE_DEFAULT_GIFT_CARD,
    payload: json
  };
}

function toggleFacetValueAction(facetKey, valueKey) {
  return {
    type: TOGGLE_FACET_VALUE,
    payload: {
      facetKey,
      valueKey
    }
  };
}

export function resetFacetValues(facetKey) {
  return {
    type: RESET_FACET_VALUES,
    payload: {
      facetKey
    }
  };
}

export function updateSort(sort) {
  return {
    type: UPDATE_SORT,
    payload: {
      sort
    }
  };
}

export function selectCollection(collectionObjectId) {
  return {
    type: SELECT_COLLECTION,
    payload: {
      collectionObjectId
    }
  };
}

export function fetchDefaultGiftCard() {
  return (dispatch) => {
    dispatch(requestDefaultGiftCard());
    return fetch('/web-api/v1/registry-collection/zola_gift_card',
      {
        credentials: 'same-origin'
      })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => dispatch(receivedDefaultGiftCard(json)));
  };
}

export function search(groupedByCollection = true) {
  return (dispatch, getState) => {
    dispatch(requestSearch());

    const sort = (getState().registryCollections.sort !== '') ? getState().registryCollections.sort : undefined;
    const collectionObjectId = getState().registryCollections.selectedCollectionObjectId !== '' ? getState().registryCollections.selectedCollectionObjectId : undefined;
    const request = {
      registry_key: getState().wedding.wedding.slug || getState().publicWebsite.wedding.slug,
      filters: getState().registryCollections.selectedFacetValues,
      sort,
      collection_object_id: collectionObjectId,
      flattened_view: !!sort || (!groupedByCollection && !collectionObjectId),
      grouped_by_collection: groupedByCollection,
    };

    return fetch('/web-api/v1/registry-collection/search',
      {
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'POST',
        body: JSON.stringify(request)
      })
      .then(handleErrors)
      .then(response => response.json())
      .then(json => dispatch(receiveSearch(json)));
  };
}

export function toggleFacetValue(facetKey, valueKey, groupByCollection = true) {
  return (dispatch) => {
    dispatch(toggleFacetValueAction(facetKey, valueKey));
    dispatch(search(groupByCollection));
  };
}



// WEBPACK FOOTER //
// ./src/actions/RegistryCollectionActions.js